import nightlyCupUrl from "../../assets/icons/nightly.svg";

export default function NightlyCupIcon({ size = 20, className = "" }) {
  const iconSize = typeof size === "number" ? `${size}px` : size;

  return (
    <img
      src={nightlyCupUrl}
      alt=""
      className={className}
      aria-hidden="true"
      style={{
        width: iconSize,
        height: iconSize,
        display: "inline-block",
        verticalAlign: "-0.125em",
        flexShrink: 0,
        objectFit: "contain",
      }}
    />
  );
}
